import { isDefined } from '@app/utils/is';
import { LegendItem as LegendItemType } from '@typings';

import { EtaLegendItem } from './EtaLegendItem';

interface DefaultProps<T> {
  items: LegendItemType<T>[];
  label?: string;
}

interface NotHoverableProps<T> extends DefaultProps<T> {
  isHoverable?: false;
  onHover?: undefined;
}

interface HoverableProps<T> extends DefaultProps<T> {
  isHoverable: true;
  onHover: (value: Maybe<T>) => void;
}

type Props<T> = NotHoverableProps<T> | HoverableProps<T>;

export const EtaLegend = <T extends string>({ isHoverable, label, items, onHover }: Props<T>) => {
  const handleHover = (value: Maybe<T>) => () => {
    onHover?.(value);
  };

  return (
    <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-2">
      {isDefined(label) && <div className="body-4">{label}</div>}
      {items.map(({ color, label: itemLabel, value }) => (
        <EtaLegendItem
          key={color}
          label={itemLabel}
          color={color}
          isHoverable={isHoverable}
          onMouseEnter={handleHover(value)}
          onMouseLeave={handleHover(null)}
        />
      ))}
    </div>
  );
};
